import React from 'react';

export const Grid3x3 = () => (
  <svg
    className="grid-3-3-svg"
    viewBox="0 0 600 600"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="layer1">
      <rect
        style={{
          fill: 'none',
          fillRule: 'evenodd',
          stroke: '#000000',
          strokeWidth: '25',
          strokeDasharray: 'none',
        }}
        id="rect1-4-8"
        width="170.12692"
        height="170.12694"
        x="414.93655"
        y="414.93655"
        rx="13.720286"
      />
      <rect
        style={{
          fill: 'none',
          fillRule: 'evenodd',
          stroke: '#000000',
          strokeWidth: '25',
          strokeDasharray: 'none',
        }}
        id="rect1-5-74"
        width="170.00705"
        height="170.00705"
        x="214.99648"
        y="414.99649"
        rx="13.710619"
      />
      <rect
        style={{
          fill: 'none',
          fillRule: 'evenodd',
          stroke: '#000000',
          strokeWidth: '25',
          strokeDasharray: 'none',
        }}
        id="rect1-0"
        width="170.00705"
        height="170.00705"
        x="14.996477"
        y="414.99646"
        rx="13.710619"
      />
      <rect
        style={{
          fill: 'none',
          fillRule: 'evenodd',
          stroke: '#000000',
          strokeWidth: '25',
          strokeDasharray: 'none',
        }}
        id="rect1-4-7"
        width="170.00705"
        height="170.00705"
        x="414.99649"
        y="214.99648"
        rx="13.710618"
      />
      <rect
        style={{
          fill: 'none',
          fillRule: 'evenodd',
          stroke: '#000000',
          strokeWidth: '25',
          strokeDasharray: 'none',
        }}
        id="rect1-5-7"
        width="170.00705"
        height="170.00705"
        x="214.99649"
        y="214.99649"
        rx="13.710619"
      />
      <rect
        style={{
          fill: 'none',
          fillRule: 'evenodd',
          stroke: '#000000',
          strokeWidth: '25',
          strokeDasharray: 'none',
        }}
        id="rect1-8"
        width="170.00705"
        height="170.00705"
        x="14.996477"
        y="214.99649"
        rx="13.710619"
      />
      <rect
        style={{
          fill: 'none',
          fillRule: 'evenodd',
          stroke: '#000000',
          strokeWidth: '25',
          strokeDasharray: 'none',
        }}
        id="rect1-4"
        width="170.00705"
        height="170.00705"
        x="414.99646"
        y="14.996477"
        rx="13.710619"
      />
      <rect
        style={{
          fill: 'none',
          fillRule: 'evenodd',
          stroke: '#000000',
          strokeWidth: '25',
          strokeDasharray: 'none',
        }}
        id="rect1-5"
        width="170.00705"
        height="170.00705"
        x="-385.00354"
        y="-185.00351"
        rx="13.710619"
        transform="scale(-1)"
      />
      <rect
        style={{
          fill: 'none',
          fillRule: 'evenodd',
          stroke: '#000000',
          strokeWidth: '25',
          strokeDasharray: 'none',
        }}
        id="rect1"
        width="170.00705"
        height="170.00705"
        x="14.996477"
        y="14.996477"
        rx="13.710619"
      />
    </g>
  </svg>
);

export const Grid3x2 = () => (
  <svg
    className="grid-3-2-svg"
    viewBox="0 0 600 600"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="layer1">
      <rect
        style={{
          fill: 'none',
          fillRule: 'evenodd',
          stroke: '#000000',
          strokeWidth: '25',
          strokeDasharray: 'none',
        }}
        id="rect1-5-74"
        width="269.88684"
        height="169.88684"
        x="315.05655"
        y="415.05655"
        rx="21.765659"
      />
      <rect
        style={{
          fill: 'none',
          fillRule: 'evenodd',
          stroke: '#000000',
          strokeWidth: '25',
          strokeDasharray: 'none',
        }}
        id="rect1-0"
        width="269.88684"
        height="169.88684"
        x="15.056575"
        y="415.05655"
        rx="21.765659"
      />
      <rect
        style={{
          fill: 'none',
          fillRule: 'evenodd',
          stroke: '#000000',
          strokeWidth: '25',
          strokeDasharray: 'none',
        }}
        id="rect1-5-7"
        width="269.88684"
        height="169.88684"
        x="315.05655"
        y="215.05658"
        rx="21.765659"
      />
      <rect
        style={{
          fill: 'none',
          fillRule: 'evenodd',
          stroke: '#000000',
          strokeWidth: '25',
          strokeDasharray: 'none',
        }}
        id="rect1-8"
        width="269.88684"
        height="169.88684"
        x="15.056575"
        y="215.05658"
        rx="21.765659"
      />
      <rect
        style={{
          fill: 'none',
          fillRule: 'evenodd',
          stroke: '#000000',
          strokeWidth: '25',
          strokeDasharray: 'none',
        }}
        id="rect1-5"
        width="269.88684"
        height="169.88684"
        x="-584.94342"
        y="-184.94341"
        rx="21.765659"
        transform="scale(-1)"
      />
      <rect
        style={{
          fill: 'none',
          fillRule: 'evenodd',
          stroke: '#000000',
          strokeWidth: '25',
          strokeDasharray: 'none',
        }}
        id="rect1"
        width="269.88684"
        height="169.88683"
        x="15.056577"
        y="15.056577"
        rx="21.765659"
      />
    </g>
  </svg>
);

export const Grid2x3 = () => (
  <svg
    className="grid-2-3-svg"
    viewBox="0 0 600 600"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="layer1">
      <rect
        style={{
          fill: 'none',
          fillRule: 'evenodd',
          stroke: '#000000',
          strokeWidth: '25',
          strokeDasharray: 'none',
        }}
        id="rect1-4-7"
        width="167.55453"
        height="267.55453"
        x="416.22275"
        y="316.22275"
        rx="13.512829"
      />
      <rect
        style={{
          fill: 'none',
          fillRule: 'evenodd',
          stroke: '#000000',
          strokeWidth: '25',
          strokeDasharray: 'none',
        }}
        id="rect1-5-7"
        width="167.55453"
        height="267.55453"
        x="216.22275"
        y="316.22275"
        rx="13.51283"
      />
      <rect
        style={{
          fill: 'none',
          fillRule: 'evenodd',
          stroke: '#000000',
          strokeWidth: '25',
          strokeDasharray: 'none',
        }}
        id="rect1-8"
        width="167.55453"
        height="267.55453"
        x="16.222734"
        y="316.22275"
        rx="13.51283"
      />
      <rect
        style={{
          fill: 'none',
          fillRule: 'evenodd',
          stroke: '#000000',
          strokeWidth: '25',
          strokeDasharray: 'none',
        }}
        id="rect1-4"
        width="167.55453"
        height="267.55453"
        x="416.22272"
        y="16.222734"
        rx="13.51283"
      />
      <rect
        style={{
          fill: 'none',
          fillRule: 'evenodd',
          stroke: '#000000',
          strokeWidth: '25',
          strokeDasharray: 'none',
        }}
        id="rect1-5"
        width="167.55453"
        height="267.55453"
        x="-383.77728"
        y="-283.77725"
        rx="13.51283"
        transform="scale(-1)"
      />
      <rect
        style={{
          fill: 'none',
          fillRule: 'evenodd',
          stroke: '#000000',
          strokeWidth: '25',
          strokeDasharray: 'none',
        }}
        id="rect1"
        width="167.55452"
        height="267.55447"
        x="16.222738"
        y="16.222738"
        rx="13.51283"
      />
    </g>
  </svg>
);

export const Grid2x2 = () => (
  <svg
    className="grid-2-2-svg"
    viewBox="0 0 600 600"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="layer1">
      <rect
        style={{
          fill: 'none',
          fillRule: 'evenodd',
          stroke: '#000000',
          strokeWidth: '25',
          strokeDasharray: 'none',
        }}
        id="rect1-5-7"
        width="269.80493"
        height="269.80487"
        x="315.09753"
        y="315.09753"
        rx="21.759048"
      />
      <rect
        style={{
          fill: 'none',
          fillRule: 'evenodd',
          stroke: '#000000',
          strokeWidth: '25',
          strokeDasharray: 'none',
        }}
        id="rect1-8"
        width="269.80493"
        height="269.80487"
        x="15.097548"
        y="315.09753"
        rx="21.759048"
      />
      <rect
        style={{
          fill: 'none',
          fillRule: 'evenodd',
          stroke: '#000000',
          strokeWidth: '25',
          strokeDasharray: 'none',
        }}
        id="rect1-5"
        width="269.80493"
        height="269.80487"
        x="-584.9024"
        y="-284.9024"
        rx="21.759048"
        transform="scale(-1)"
      />
      <rect
        style={{
          fill: 'none',
          fillRule: 'evenodd',
          stroke: '#000000',
          strokeWidth: '25',
          strokeDasharray: 'none',
        }}
        id="rect1"
        width="269.80493"
        height="269.80487"
        x="15.097548"
        y="15.097548"
        rx="21.759048"
      />
    </g>
  </svg>
);
